import {iconMap} from '@eitje/assets'
import _ from 'lodash'
import {ftime, date} from '@eitje/utils'

const ICON_MAP = {
	reset: 'arrow-circle-left',
	download: 'download',
}

const DATE_FORMAT = 'DD-MM-YYYY'

const getToolbarIcon = icon => `<img class="graph-toolbar-icon" src="${iconMap[`flaticon/regular/${icon}`]}" />`

export const buildToolBar = ({series, graphName}) => {
	const xValues = _.map(series[0]?.data, ({x}) => date(x))
	const from = ftime(_.first(xValues), DATE_FORMAT)
	const till = ftime(_.last(xValues), DATE_FORMAT)
	const exportFilename = `${graphName}-from-${from}-till-${till}`

	return {
		tools: {
			..._.mapValues(ICON_MAP, getToolbarIcon),
		},
		export: {
			csv: {
				filename: exportFilename,
			},
			png: {filename: exportFilename},
			// default quality of png is very poor. Increase scale to improve quality.
			scale: 10,
		},
	}
}
